export default __webpack_public_path__ + "static/media/cover_gemswar.b42c08b2.mp4";